import { render, staticRenderFns } from "./EditStudentAcceptedChannel.vue?vue&type=template&id=064c733a&scoped=true&"
import script from "./EditStudentAcceptedChannel.vue?vue&type=script&lang=js&"
export * from "./EditStudentAcceptedChannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064c733a",
  null
  
)

export default component.exports